import { z } from 'zod';

/** Materialized graph node vocabulary, shared by HTTP and both UI widgets. */
export const DocLinkTypeSchema = z.enum([
  'sale', 'ddt', 'invoice', 'credit_note_active', 'debit_note_active',
  'purchase_order', 'ddt_passivo', 'supplier_invoice', 'transfer',
]);
export type DocLinkType = z.infer<typeof DocLinkTypeSchema>;

export const DocLinkNodeSchema = z.object({
  type: DocLinkTypeSchema,
  id: z.string().uuid(),
});
export type DocLinkNode = z.infer<typeof DocLinkNodeSchema>;

export const DocLinkSchema = DocLinkNodeSchema.extend({
  number: z.string().nullable(),
  date: z.string().nullable(),
  status: z.string().nullable(),
  amount: z.number().finite().nullable(),
  label: z.string(),
});
export type DocLink = z.infer<typeof DocLinkSchema>;

export const DocLinkResultSchema = z.object({
  origins: z.array(DocLinkSchema),
  outgoing: z.array(DocLinkSchema),
});
export type DocLinkResult = z.infer<typeof DocLinkResultSchema>;

export const DocLinkBatchInputSchema = z.object({
  items: z.array(DocLinkNodeSchema).max(200),
});
export type DocLinkBatchInput = z.infer<typeof DocLinkBatchInputSchema>;

export const DocLinkBatchResultSchema = z.record(DocLinkResultSchema);
export type DocLinkBatchResult = z.infer<typeof DocLinkBatchResultSchema>;